import {Component, OnInit, Output, Input, EventEmitter} from '@angular/core';
import {ProfileService} from '../profile.service';

@Component({
    selector: 'main-profile-change-category',
    template: require('./profile-change-category.component.html'),
    providers: [ProfileService]
})

export class MainProfileChangeCategoryComponent implements OnInit {
                
    @Input('subroleCat') userSubrole: number;
    @Output('subroleUpdatedCat') subroleUpdated = new EventEmitter();

    category: number;
    
    constructor(private _profileService: ProfileService) {
        
    }

    ngOnInit() {
        if(this.userSubrole==1 || this.userSubrole==2 || this.userSubrole==8) {
            this.category = 1;
        }
        else if(this.userSubrole==3 || this.userSubrole==4 || this.userSubrole==9) {
            this.category = 2;
        }
    }        

   changeCategory(cat: number) {
       this.category = cat;
       this.subroleUpdated.emit({
            value: cat
       });
   }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/main/profile/profile_change_category/profile-change-category.component.ts
 **/